import React from 'react';
import FileSaver from 'file-saver';
import { User } from '@upstart/harmony/lib/legos/userTypes';

import UserService from '../../services/UserService';

const getCSVContent = (users: User[]): string => {
  let csvContent = `${Object.keys(users[0]).join(',')}\n`;
  for (const user of users) {
    const values = Object.values(user);
    for (let i = 0; i < values.length; i += 1) {
      csvContent += `"${values[i]}"`;
      if (i < values.length - 1) {
        csvContent += ',';
      }
    }
    csvContent += '\n';
  }

  return csvContent;
};

const UsersToCSVButton = ({
  userType,
  label,
}: {
  userType: string;
  label: string;
}) => {
  const exportHandler = () => {
    UserService.getUsersForExport(userType).then(users => {
      if (users && users.length > 0) {
        const blob = new Blob([getCSVContent(users)], { type: 'text/csv' });
        FileSaver.saveAs(blob, `${userType}.csv`);
      }
    });
  };

  return (
    <button
      type="button"
      className="btn btn-primary btn-large new-btn-space"
      onClick={exportHandler}
    >
      {label}
    </button>
  );
};

export default UsersToCSVButton;
